export default "__VITE_ASSET__QZHd5doB__"